import Vue from 'vue';
import store from './../../store';
import transferTransformer from './../../transformers/transfer';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const transfers = transferTransformer.fetchCollection(data.data);

  store.dispatch('FetchAllTransfers', transfers);
  resolve(transfers);
};

const failed = () => {};

export default (params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/transfers', params))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/transfer/all.js